module.exports = __webpack_public_path__ + "static/media/location96.1f449429.svg";